import { lazy, FC, Suspense } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import { VisaDashboardWrapper } from '../pages/visa_dashboard/VisaDashboardWrapper'
import { MenuTestPage } from '../pages/MenuTestPage'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import { useAuth } from '../modules/auth';

const PrivateRoutes = () => {
	const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
	const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
	const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
	const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
	const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
	const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
	const RolesPage = lazy(() => import('../modules/role-management/MainPage'))
	const NetWorthRangePage = lazy(() => import('../modules/networthrange-management/MainPage'))
	const DegreePage = lazy(() => import('../modules/degree-management/MainPage'))
	const ProfessionPage = lazy(() => import('../modules/profession-management/MainPage'))
	const ProductPage = lazy(() => import('../modules/product-management/MainPage'))
	const InquirytypePage = lazy(() => import('../modules/inquirytype-management/MainPage'))
	const InquirystatusPage = lazy(() => import('../modules/inquirystatus-management/MainPage'))
	const EducationstreamPage = lazy(() => import('../modules/educationstream-management/MainPage'))
	const EducationcredentialPage = lazy(() => import('../modules/educationcredential-management/MainPage'))
	const FilestagePage = lazy(() => import('../modules/filestage-management/MainPage'))
	const FilestatusPage = lazy(() => import('../modules/filestatus-management/MainPage'))
	const MaritalstatusPage = lazy(() => import('../modules/maritalstatus-management/MainPage'))
	const TasktypePage = lazy(() => import('../modules/tasktype-management/MainPage'))
	const TaskstatusPage = lazy(() => import('../modules/taskstatus-management/MainPage'))
	const CountryPage = lazy(() => import('../modules/country-management/MainPage'))
	const NocPage = lazy(() => import('../modules/noc-management/MainPage'))
	const InstitutePage = lazy(() => import('../modules/institute-management/MainPage'))
	const CampusePage = lazy(() => import('../modules/campuse-management/MainPage'))
	const InquirysourcePage = lazy(() => import('../modules/inquirysource-management/MainPage'))
	const StatePage = lazy(() => import('../modules/state-management/MainPage'))
	const InquirysubsourcePage = lazy(() => import('../modules/inquirysubsource-management/MainPage'))
	const CityPage = lazy(() => import('../modules/city-management/MainPage'))
	// const AreaPage                       = lazy(() => import('../modules/area-management/MainPage'))
	const CoursePage = lazy(() => import('../modules/course-management/MainPage'))
	const RelatioshipPage = lazy(() => import('../modules/relationship-management/MainPage'))
	const OrganizationtypePage = lazy(() => import('../modules/organizationtype-management/MainPage'))
	const LanguagePage = lazy(() => import('../modules/language-management/MainPage'))
	const InquiryPage = lazy(() => import('../modules/inquiry-management/MainPage'))
	const ProductCategoryPage = lazy(() => import('../modules/productcategory-management/MainPage'))
	const EducationPage = lazy(() => import('../modules/educationdegree-management/MainPage'))
	const VisafilePage = lazy(() => import('../modules/visafile-management/MainPage'))
	const VisafamilyPage = lazy(() => import('../modules/visafamily-management/MainPage'))
	const VisaApplicantPage = lazy(() => import('../modules/visaapplicant-management/MainPage'))
	const AttributePage = lazy(() => import('../modules/productattribute-management/MainPage'))
	const DocumentcategoryPage = lazy(() => import('../modules/documentcategory-management/MainPage'))
	const DocumenttypePage = lazy(() => import('../modules/documenttype-management/MainPage'))
	const TaskPage = lazy(() => import('../modules/task-management/MainPage'))
	// const RelativeInForignWithStatusPage = lazy(() => import('../modules/relativeinforeignwithstatus-management/MainPage'))
	const FollowupPage = lazy(() => import('../modules/followupmethod-management/MainPage'))
	const ClientFollowupDetailPage = lazy(() => import('../modules/clientfollowupdetail-management/MainPage'))
	const PointFieldPage = lazy(() => import('../modules/pointfield-management/MainPage'))
	const PointFieldOptionValuePage = lazy(() => import('../modules/pointfieldoptionvalue-management/MainPage'))
	const PointCalculatePage = lazy(() => import('../modules/pointcalculate-management/MainPage'))
	const ProductCategoryPoint = lazy(() => import('../modules/productcategorypoint-management/MainPage'))
	const ExperiencePage = lazy(() => import('../modules/experience-management/MainPage'))
	const ResidenceStatusPage = lazy(() => import('../modules/residencestatus-management/MainPage'))
	const InquiryImportPage = lazy(() => import('../modules/inquiryimport-management/MainPage'))
	const ReportPage = lazy(() => import('../modules/report-management/MainPage'))
	const MonitoringChartPage = lazy(() => import('../modules/monitoringchart-management/MainPage'))
	const VisaFileCheck = lazy(() => import('../modules/filecheck-management/MainPage'))
	const VisaFileCheckList = lazy(() => import('../modules/filechecklist-management/MainPage'))
	const UserCoursePage = lazy(() => import('../modules/usercourse-management/MainPage'))
	const NotificationPage = lazy(() => import('../modules/notification-management/MainPage'))
	const EmailDocumentPage = lazy(() => import('../modules/emaildocument-management/MainPage'))
	const CampusCoursePage = lazy(() => import('../modules/campuscoursedetail-management/MainPage'))


	const { currentUser } = useAuth();
	const authUser = currentUser?.user;
	let routeElements;

	if (authUser && authUser.roles && authUser.roles.length > 0) {
		const slugs = authUser.roles[0].slug;
		if (slugs === 'VisaExecutive' || slugs === 'VisaFileTeam') {
			routeElements = (
				<Route path='auth/*' element={<Navigate to='/visadashboard' />} />
			);
		}
		else if (slugs === 'Client') {
			routeElements = (
				<Route path='auth/*' element={<Navigate to={`/visafile-management/edit/${authUser.id}`} />} />
			);
		}
		else {
			routeElements = (
				<Route path='auth/*' element={<Navigate to='/dashboard' />} />
			);
		}
	}

	return (
		<Routes>
			<Route element={<MasterLayout />}>
				{/* Redirect to Dashboard after success login/registartion */}
				{/* <Route path='auth/*' element={<Navigate to='/dashboard' />} /> */}
				{routeElements}
				{/* Pages */}
				<Route path='dashboard' element={<DashboardWrapper />} />
				<Route path='visadashboard' element={<VisaDashboardWrapper />} />
				<Route path='builder' element={<BuilderPageWrapper />} />
				<Route path='menu-test' element={<MenuTestPage />} />
				{/* Lazy Modules */}
				<Route
					path='crafted/pages/profile/*'
					element={
						<SuspensedView>
							<ProfilePage />
						</SuspensedView>
					}
				/>
				<Route
					path='crafted/pages/wizards/*'
					element={
						<SuspensedView>
							<WizardsPage />
						</SuspensedView>
					}
				/>
				<Route
					path='crafted/widgets/*'
					element={
						<SuspensedView>
							<WidgetsPage />
						</SuspensedView>
					}
				/>
				<Route
					path='crafted/account/*'
					element={
						<SuspensedView>
							<AccountPage />
						</SuspensedView>
					}
				/>
				<Route
					path='apps/chat/*'
					element={
						<SuspensedView>
							<ChatPage />
						</SuspensedView>
					}
				/>
				<Route
					path='apps/user-management/*'
					element={
						<SuspensedView>
							<UsersPage />
						</SuspensedView>
					}
				/>
				<Route
					path='role-management/*'
					element={
						<SuspensedView>
							<RolesPage />
						</SuspensedView>
					}
				/>
				<Route
					path='networthrange-management/*'
					element={
						<SuspensedView>
							<NetWorthRangePage />
						</SuspensedView>
					}
				/>
				<Route
					path='degree-management/*'
					element={
						<SuspensedView>
							<DegreePage />
						</SuspensedView>
					}
				/>
				<Route
					path='profession-management/*'
					element={
						<SuspensedView>
							<ProfessionPage />
						</SuspensedView>
					}
				/>
				<Route
					path='product-management/*'
					element={
						<SuspensedView>
							<ProductPage />
						</SuspensedView>
					}
				/>
				<Route
					path='inquirytype-management/*'
					element={
						<SuspensedView>
							<InquirytypePage />
						</SuspensedView>
					}
				/>
				<Route
					path='inquirystatus-management/*'
					element={
						<SuspensedView>
							<InquirystatusPage />
						</SuspensedView>
					}
				/>
				<Route
					path='educationstream-management/*'
					element={
						<SuspensedView>
							<EducationstreamPage />
						</SuspensedView>
					}
				/>
				<Route
					path='educationcredential-management/*'
					element={
						<SuspensedView>
							<EducationcredentialPage />
						</SuspensedView>
					}
				/>
				<Route
					path='filestage-management/*'
					element={
						<SuspensedView>
							<FilestagePage />
						</SuspensedView>
					}
				/>
				<Route
					path='filestatus-management/*'
					element={
						<SuspensedView>
							<FilestatusPage />
						</SuspensedView>
					}
				/>
				<Route
					path='maritalstatus-management/*'
					element={
						<SuspensedView>
							<MaritalstatusPage />
						</SuspensedView>
					}
				/>
				<Route
					path='tasktype-management/*'
					element={
						<SuspensedView>
							<TasktypePage />
						</SuspensedView>
					}
				/>
				<Route
					path='taskstatus-management/*'
					element={
						<SuspensedView>
							<TaskstatusPage />
						</SuspensedView>
					}
				/>
				<Route
					path='country-management/*'
					element={
						<SuspensedView>
							<CountryPage />
						</SuspensedView>
					}
				/>
				<Route
					path='noc-management/*'
					element={
						<SuspensedView>
							<NocPage />
						</SuspensedView>
					}
				/>
				<Route
					path='institute-management/*'
					element={
						<SuspensedView>
							<InstitutePage />
						</SuspensedView>
					}
				/>
				<Route
					path='campuse-management/*'
					element={
						<SuspensedView>
							<CampusePage />
						</SuspensedView>
					}
				/>
				<Route
					path='inquirysource-management/*'
					element={
						<SuspensedView>
							<InquirysourcePage />
						</SuspensedView>
					}
				/>
				<Route
					path='state-management/*'
					element={
						<SuspensedView>
							<StatePage />
						</SuspensedView>
					}
				/>
				<Route
					path='inquirysubsource-management/*'
					element={
						<SuspensedView>
							<InquirysubsourcePage />
						</SuspensedView>
					}
				/>
				<Route
					path='city-management/*'
					element={
						<SuspensedView>
							<CityPage />
						</SuspensedView>
					}
				/>
				{/* <Route
				path='area-management/*'
				element={
					<SuspensedView>
						<AreaPage />
					</SuspensedView>
				}
			/> */}
				<Route
					path='course-management/*'
					element={
						<SuspensedView>
							<CoursePage />
						</SuspensedView>
					}
				/>
				<Route
					path='relationship-management/*'
					element={
						<SuspensedView>
							<RelatioshipPage />
						</SuspensedView>
					}
				/>
				<Route
					path='organizationtype-management/*'
					element={
						<SuspensedView>
							<OrganizationtypePage />
						</SuspensedView>
					}
				/>
				<Route
					path='language-management/*'
					element={
						<SuspensedView>
							<LanguagePage />
						</SuspensedView>
					}
				/>
				<Route
					path='productcategory-management/*'
					element={
						<SuspensedView>
							<ProductCategoryPage />
						</SuspensedView>
					}
				/>
				<Route
					path='educationdegree-management/*'
					element={
						<SuspensedView>
							<EducationPage />
						</SuspensedView>
					}
				/>
				<Route
					path='inquiry-management/*'
					element={
						<SuspensedView>
							<InquiryPage />
						</SuspensedView>
					}
				/>
				<Route
					path='visafile-management/*'
					element={
						<SuspensedView>
							<VisafilePage />
						</SuspensedView>
					}
				/>
				<Route
					path='visafamily-management/*'
					element={
						<SuspensedView>
							<VisafamilyPage />
						</SuspensedView>
					}
				/>
				<Route
					path='visaapplicant-management/*'
					element={
						<SuspensedView>
							<VisaApplicantPage />
						</SuspensedView>
					}
				/>
				<Route
					path='productattribute-management/*'
					element={
						<SuspensedView>
							<AttributePage />
						</SuspensedView>
					}
				/>
				<Route
					path='documentcategory-management/*'
					element={
						<SuspensedView>
							<DocumentcategoryPage />
						</SuspensedView>
					}
				/>
				<Route
					path='documenttype-management/*'
					element={
						<SuspensedView>
							<DocumenttypePage />
						</SuspensedView>
					}
				/>
				<Route
					path='clientdocumentdetail-management/*'
					element={
						<SuspensedView>
							<DocumentcategoryPage />
						</SuspensedView>
					}
				/>
				<Route
					path='task-management/*'
					element={
						<SuspensedView>
							<TaskPage />
						</SuspensedView>
					}
				/>
				<Route
					path='followupmethod-management/*'
					element={
						<SuspensedView>
							<FollowupPage />
						</SuspensedView>
					}
				/>

				<Route
					path='clientfollowupdetail-management/*'
					element={
						<SuspensedView>
							<ClientFollowupDetailPage />
						</SuspensedView>
					}
				/>

				<Route
					path='pointfield-management/*'
					element={
						<SuspensedView>
							<PointFieldPage />
						</SuspensedView>
					}
				/>

				<Route
					path='pointfieldoptionvalue-management/*'
					element={
						<SuspensedView>
							<PointFieldOptionValuePage />
						</SuspensedView>
					}
				/>

				<Route
					path='pointcalculate-management/*'
					element={
						<SuspensedView>
							<PointCalculatePage />
						</SuspensedView>
					}
				/>

				<Route
					path='productcategorypoint-management/*'
					element={
						<SuspensedView>
							<ProductCategoryPoint />
						</SuspensedView>
					}
				/>

				<Route
					path='experience-management/*'
					element={
						<SuspensedView>
							<ExperiencePage />
						</SuspensedView>
					}
				/>

				<Route
					path='residencestatus-management/*'
					element={
						<SuspensedView>
							<ResidenceStatusPage />
						</SuspensedView>
					}
				/>

				<Route
					path='inquiryimport-management/*'
					element={
						<SuspensedView>
							<InquiryImportPage />
						</SuspensedView>
					}
				/>

				<Route
					path='report-management/*'
					element={
						<SuspensedView>
							<ReportPage />
						</SuspensedView>
					}
				/>

				<Route
					path='monitoringchart-management/*'
					element={
						<SuspensedView>
							<MonitoringChartPage />
						</SuspensedView>
					}
				/>

				<Route
					path='clientfilecheck-management/*'
					element={
						<SuspensedView>
							<VisaFileCheck />
						</SuspensedView>
					}
				/>

				<Route
					path='clientfilechecklist-management/*'
					element={
						<SuspensedView>
							<VisaFileCheckList />
						</SuspensedView>
					}
				/>

				<Route
					path='usercourse-management/*'
					element={
						<SuspensedView>
							<UserCoursePage />
						</SuspensedView>
					}
				/>

				<Route
					path='campuscourse-management/*'
					element={
						<SuspensedView>
							<CampusCoursePage />
						</SuspensedView>
					}
				/>

				<Route
					path='notification-management/*'
					element={
						<SuspensedView>
							<NotificationPage />
						</SuspensedView>
					}
				/>

				<Route
					path='emaildocument-management/*'
					element={
						<SuspensedView>
							<EmailDocumentPage />
						</SuspensedView>
					}
				/>


				{/* Page Not Found */}
				<Route path='*' element={<Navigate to='/error/404' />} />
			</Route>
		</Routes>
	)
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
	const baseColor = getCSSVariableValue('--kt-primary')
	TopBarProgress.config({
		barColors: {
			'0': baseColor,
		},
		barThickness: 1,
		shadowBlur: 5,
	})
	return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }